import React from 'react';

import styles from './unauthorized-placeholder.module.scss';

export const PageUnauthorized = () => (
  <div className={styles['container']}>
    <img src="/images/crime-outline.svg" alt="unauthorized-img" />
    <p className={styles['title']}>No access to this project</p>
    <p className={styles['description']}>You do not have access to this document</p>
  </div>
);
